export class Project {
    projectUUID: string;
    projectID: any;
    projectName: string;
    description: string;
    dateUpdate: Date;
    search: string;
    thumb: string;
    distributionID: string;
    extraDatas: any = {};
    hasDiscount: boolean = false;
    hasQuotation: boolean;
    quotationExpirationDate?: Date;
}